export default __webpack_public_path__ + "static/media/313.58ac437f.png";